<script>
    const getToken = true;
    let width = 705;
    export default
        {
            getToken,
            width
        }
</script>